// Catalog warming and the mounted player use the same access-scoped memory cache.
export async function loadHorenContent({type = 'codes', level = 'b1', theme = ''}, {force = false} = {}) {
  const query = new URLSearchParams({type, level, theme});
  const url = `/database/horen-theme.json?${query}`;
  const payload = window.ZDeutschDataCache?.fetchJson
    ? await window.ZDeutschDataCache.fetchJson(url, {force})
    : await fetch(url, {credentials:'same-origin', headers:{Accept:'application/json'}, signal:AbortSignal.timeout(15000), cache:'no-store'}).then(async response=>{if(!response.ok)throw new Error(`Hören data: ${response.status}`);return response.json();});
  if (!payload?.levels?.[level]?.themes?.[payload.loadedTheme]) throw new Error('Invalid Hören data');
  return payload;
}
window.ZDeutschHorenContent = {load:loadHorenContent, clear:()=>window.ZDeutschDataCache?.clear()};
